import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class CalculationDetails<T extends EMode = EMode.entity> {
  /** Alias: code */
  id?: string;
  /** Alias: sumPurchasePrice */
  sumPurchasePrice?: any;
  /** Alias: dbPercent */
  dbPercent?: any;
  /** Alias: netValueMainCurrency */
  netValueMainCurrency?: any;
  /** Alias: grossValueMainCurrency */
  grossValueMainCurrency?: any;

  __typename?: string;
}

const fields: FieldDefinitions<CalculationDetails> = {
  id: {
    alias: 'code',
  },
  sumPurchasePrice: {
    alias: 'sumPurchasePrice',
  },
  dbPercent: {
    alias: 'dbPercent',
  },
  netValueMainCurrency: {
    alias: 'netValueMainCurrency',
  },
  grossValueMainCurrency: {
    alias: 'grossValueMainCurrency',
  },
  __typename: {
    alias: '__typename',
  },
};

export const calculationDetailsEntityDefinition: EntitiyDefinition<CalculationDetails> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'CalculationDetails',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
